<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Signering</h2>
      <h4
        class="text-center mb-3"
      >Signering gjøres ved at hver deltaker skriver sin underskrift i boksen ved sitt navn. Dette gjøres ved å bruke en finger for å skrive signatur.</h4>
    </v-flex>
    <div v-if="readyForSigning && renderComponent">
      <template v-for="(item, index) in people">
        <v-flex xs12 class="mb-4" :key="index+'1'">
          <v-card>
            <v-toolbar color="accent" :dark="protocol.dark">
              <v-toolbar-title v-if="item.companyName">{{item.companyName}}</v-toolbar-title>
              <v-toolbar-title v-else>{{item.firstname}} {{item.lastname}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-side-icon>
                <v-icon>mdi-pencil</v-icon>
              </v-toolbar-side-icon>
            </v-toolbar>
            <vueSignature
              ref="signature"
              :sigOption="signOptions"
              :w="'100%'"
              :h="'300px'"
              :fromDataURL="item.signature"
            ></vueSignature>
          </v-card>
        </v-flex>
      </template>
    </div>
    <div v-else>
      <v-alert :value="true" color="warning" type="warning">
        Alle sider i protokollen må være fullført før signering kan gjennomføres.
        Du kan enkelt se i menyen hvilke sider som trenger gjennomgang.
      </v-alert>
    </div>
    <v-flex xs12 class="text-center" v-if="readyForSigning">
      <v-btn flat small @click="previous">Forrige</v-btn>
      <v-btn v-if="$store.state.online" large :loading="loader" :disabled="loader" color="success" @click="doSigning">
        Godkjenn og fullfør protokoll
        <template v-slot:loader>
          <span class="custom-loader">
            <v-icon light>mdi-loading</v-icon>
          </span>
        </template>
      </v-btn>
      <v-alert v-else :value="true" color="warning" type="warning">
        Internett-tilkobling er ikke aktiv: Det ser ikke ut til at du er på nett, og kan derfor ikke fullføre protokollen.
        Sørg for at du er et sted med dekning, eller er tilkoblet internett.
      </v-alert>
    </v-flex>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-toolbar :dark="protocol.dark" color="primary">
        <v-toolbar-title>Protokoll fullført</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-flex cs12 align-center text-center>
            <img :src="protocol.logo" class="mb-3 logo-img" />
          </v-flex>
          <v-flex xs12 sm8 offset-sm2 align-center text-center>
            <h1>Gratulerer!</h1>
          </v-flex>
          <v-flex xs12 sm8 offset-sm2 align-center text-center>
            <h3>
              Protokollen er nå gjennomført.
              <br />En PDF med alle punkter i protokollen vil bli sendt til alle deltakere.
            </h3>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="notCompleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Signering</v-card-title>
        <v-card-text>Alle parter må signere protokollen</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="notCompleteDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import step from "../../../mixins/step";
export default {
  mixins: [step],
  data() {
    return {
      dialog: false,
      notCompleteDialog: false,
      loader: false,
      signOptions: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)"
      },
      readyForSigning: false,
      renderComponent: true
    };
  },
  mounted: function() {
    this.readyForSigning = this.stepsFinished();
  },
  activated: function() {
    this.renderComponent = false;
    this.readyForSigning = this.stepsFinished();
    this.$nextTick(() => {
      // Add the component back in
      this.renderComponent = true;
    });
  },
  computed: {
    people: function() {
      let peopleList = [];
      for(let type in this.protocol.saved_values.participants) {
        for(let person in this.protocol.saved_values.participants[type]) {
          if(this.protocol.saved_values.participants[type][person].email) {
             peopleList.push(this.protocol.saved_values.participants[type][person])
          }
        }
      }
      return peopleList;
    },

    allSigned: function() {
      let all = true;
      for (let key in this.people) {
        if (!this.$refs.signature[key].isEmpty()) {
          let png = this.$refs.signature[key].save();
          this.setSignature(key, png);
        } else {
          all = false;
        }
      }
      return all;
    }
  },
  components: {},
  methods: {
    stepsFinished() {
      let index = 0;
      for (let step in this.protocol.saved_values.steps) {
        if(step !== 'sale-signing')
        if (!this.protocol.saved_values.steps[step].finished) {
          return false;
        }
      }
      return true;
    },
    doSigning() {
      this.loader = true;
      if (this.allSigned) {
        this.$emit("page-finished");
        if (this.stepsFinished()) {
          this.axios
            .post(
              process.env.VUE_APP_PROTOCOL_API +
                "protocols/" +
                this.$store.state.protocolHash +
                "/finished",
              this.$store.state.protocol.saved_values
            )
            .then(response => {
              this.dialog = true;
              this.$ga.event(
                "protocol",
                "protocol_signed",
                this.$store.state.protocolHash
              );
              return response;
            })
            .catch(error => {
              this.loader = false;
              this.$emit(
                "error",
                "Det skjedde en feil ved signering av protokoll. Sørg for at du er koblet til internett og forsøk på nytt"
              );
            });
        } else {
          this.loader = false;
          this.$emit(
            "error",
            "Alle steg må være ferdig utfylt før protokollen kan fullføres. Du kan se i menyen hvilke steg som ikke er ferdige."
          );
        }
      } else {
        this.loader = false;
        this.notCompleteDialog = true;
      }
    },
    previous: function() {
      this.$emit("previous-page");
    },
    setSignature: function(key, signature) {
      this.people[key].signature = signature;
    }
  }
};
</script>
